import React, { useState } from "react";
import { MyPortfolioReview } from "./Tab3Components/MyPortfolioReview";
import { MyActionable } from "./Tab3Components/MyActionable";
import { MyReports } from "./Tab3Components/MyReports";
import { MyGoalEvents } from "./Tab3Components/MyGoalEvents";
import { useSelector } from "react-redux";

export const Tab3 = ({ setIsViewArchivedEvent,historyActiveTab,setHistoryActiveTab }) => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");

  const { clientData } = useSelector((state) => state.client);

  return (
    <div>
      <div className="row mb-3 justify-content-center">
        <ul className="nav nav-tabs justify-content-center row" id="myTab1" role="tablist">
          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${historyActiveTab === "Goals" ? "active" : ""}`}
              id="Goals-tab"
              data-bs-toggle="tab"
              data-bs-target="#Goals-tab-pane"
              type="button"
              role="tab"
              aria-controls="Goals-tab-pane"
              aria-selected={historyActiveTab === "Goals"}
              onClick={() => setHistoryActiveTab("Goals")}
            >
              <span className={`fs-21 mt-3 ${historyActiveTab !== "Goals" && "clrgreen-black"}`}>My Goal Events</span>
            </button>
          </li>

          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${historyActiveTab === "Portfolio" ? "active" : ""}`}
              id="Portfolio-tab"
              data-bs-toggle="tab"
              data-bs-target="#Portfolio-tab-pane"
              type="button"
              role="tab"
              aria-controls="Portfolio-tab-pane"
              aria-selected={historyActiveTab === "Portfolio"}
              onClick={() => setHistoryActiveTab("Portfolio")}
            >
              <span className={`fs-21 mt-3 ${historyActiveTab !== "Portfolio" && "clrgreen-black"}`}>My Portfolio Reviews</span>
            </button>
          </li>

          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${historyActiveTab === "Action" ? "active" : ""}`}
              id="Action-tab"
              data-bs-toggle="tab"
              data-bs-target="#Action-tab-pane"
              type="button"
              role="tab"
              aria-controls="Action-tab-pane"
              aria-selected={historyActiveTab === "Action"}
              onClick={() => setHistoryActiveTab("Action")}
            >
              <span className={`fs-21 mt-3 ${historyActiveTab !== "Action" && "clrgreen-black"}`}>My Actionables</span>
            </button>
          </li>

          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${historyActiveTab === "Reports" ? "active" : ""}`}
              id="Reports-tab"
              data-bs-toggle="tab"
              data-bs-target="#Reports-tab-pane"
              type="button"
              role="tab"
              aria-controls="Reports-tab-pane"
              aria-selected={historyActiveTab === "Reports"}
              onClick={() => setHistoryActiveTab("Reports")}
            >
              <span className={`fs-21 mt-3 ${historyActiveTab !== "Reports" && "clrgreen-black"}`}>My Reports</span>
            </button>
          </li>
        </ul>
      </div>

      <div className="tab-content" id="myTabContent1">
        <div
          className={`tab-pane fade ${historyActiveTab === "Goals" ? "show active" : ""}`}
          id="Goals-tab-pane"
          role="tabpanel"
          aria-labelledby="Goals-tab"
        >
          <MyGoalEvents roomId={roomId} setIsViewArchivedEvent={setIsViewArchivedEvent} />
        </div>

        <div
          className={`tab-pane fade ${historyActiveTab === "Portfolio" ? "show active" : ""}`}
          id="Portfolio-tab-pane"
          role="tabpanel"
          aria-labelledby="Portfolio-tab"
        >
          <MyPortfolioReview roomId={roomId} />
        </div>

        <div
          className={`tab-pane fade ${historyActiveTab === "Action" ? "show active" : ""}`}
          id="Action-tab-pane"
          role="tabpanel"
          aria-labelledby="Action-tab"
        >
          <MyActionable roomId={roomId} clientData={clientData} />
        </div>

        <div
          className={`tab-pane fade ${historyActiveTab === "Reports" ? "show active" : ""}`}
          id="Reports-tab-pane"
          role="tabpanel"
          aria-labelledby="Reports-tab"
        >
          <MyReports roomId={roomId} setHistoryActiveTab={setHistoryActiveTab} />
        </div>
      </div>
    </div>
  );
};
